var watchlistPositionAdd = {
	title: "Crea posizione",
	subtitle: "Watchlist: {value}",
	noSelectedPositions: "Al momento, non ci sono posizioni selezionate da creare alla watchlist.",
	singleSelectedPosition: "C'è 1 posizione selezionata da creare alla watchlist.",
	multipleSelectedPositions: "Ci sono {value} posizioni selezionate da creare alla watchlist.",
	submit: "Invia",
	cancel: "Annulla",
	remove: "Elimina",
	validationErrors: {
		positionExists: "La tua selezione è già nella tua watchlist"
	},
	noWatchlists: {
		title: "Info",
		message: "Nessuna watchlist è stata ancora creata."
	}
};
var it = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { it as default, watchlistPositionAdd };
